export default {
  arrives: 'Llegada',
  journeyDuration: 'Duración del viaje',
}
